export const deliveryAddressText = address => address?.completeAddress?.trim() ||
  ['additionalLocationInfo', 'sitio', 'barangay', 'municipality'].map(field => String(address?.[field] || '').trim()).filter(Boolean).join(', ');
export const deliveryAddressLabel = address => address?.type === 'OTHER' && address.otherLabel
  ? `OTHER (${address.otherLabel})` : address?.type || 'Address';
